// See Design > UI, "Principles": sample data is labelled as sample data. Put the mark beside the label of the value it qualifies.
export function SampleMark({ title = "Sample: the Exchange doesn't record this value yet, so Studio shows an example" }: { title?: string }) {
  return <span class="ui-sample" title={title}>Sample</span>;
}
